module.exports = __webpack_public_path__ + "img/openhouse-header.ff78f5f4.png";